module.exports = __webpack_public_path__ + "static/media/savio14.0001f2c6.jpg";